import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import ProfileDropdown from '../../Components/Common/ProfileDropdown';
import SearchOption from '../../Components/Common/SearchOption';
import Settings from '../../Components/Common/Settings';

import sshLogo from '../../assets/images/ssh.png';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const [search, setSearch] = useState(false);

    const history = useHistory();

    const toogleSearch = () => {
        setSearch(!search);
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <div className="d-flex align-items-center me-10 pe-4">
                                <img
                                    id="sshLogo"
                                    src={sshLogo}
                                    alt="SSH logo"
                                    className="cursor-pointer SSH_logo"
                                    onClick={() => history.push('/content')}
                                />
                            </div>

                            {<SearchOption />}
                        </div>

                        <div className="d-flex align-items-center">
                            {
                                <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                    <DropdownToggle
                                        type="button"
                                        tag="button"
                                        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    >
                                        <i className="ri-search-line search-widget-icon fs-22"></i>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                        <SearchOption small />
                                    </DropdownMenu>
                                </Dropdown>
                            }

                            {/* {<Settings />}

                            <ProfileDropdown /> */}
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
